<template>
	<div class="header">
		<div class="w1200">
			<a href="/#/index" class="logo"><img src="../../assets/img/logo.png" alt=""></a>
		</div>
		
		<div class="top-banner">
			<img class="img" v-if="bannerImg" :src=" bannerImg.value" alt="">
		</div>
	</div>
</template>

<script>
export default {
	data () {
		return {
			bannerImg:null,
		}
	},
	
	computed:{

	},
	
	mounted(){
		this.getBanner('topBanner',1).then((list)=>{
			this.bannerImg = list[0]
		})
	},
	 
	methods:{
		
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import '~@/assets/css/common.less';
.header{
	.logo{
		font-size:0; line-height:0; padding:21px 0; display:inline-block;
		img{height:48px; }
	}
	.top-banner{ 
		 width:100%; min-width: 1200px; overflow: hidden; font-size:0; line-height: 0;
		.img{position:relative; left:50%; width:1920px; margin-left:-960px;}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue